import { parseSemver } from '@sentry/utils';

const NODE_VERSION = parseSemver(process.versions.node) ;

export { NODE_VERSION };
//# sourceMappingURL=nodeVersion.js.map
